import type { DruidOrFilter } from '../../../../../../../server/modules/druid';
import type { Filter } from '../../../../../main/types/druidTypes';

export type OrType = 'or';
export const OR_TYPE: OrType = 'or';

export default class OrFilter implements DruidOrFilter {
  dimension: void;

  field: void;

  fields: Filter[];

  pattern: void;

  type: OrType;

  values: void;

  constructor(fields: Filter[]) {
    this.type = OR_TYPE;
    this.fields = fields ? fields : [];
  }
}
